<div class="users-page">
  <app-page-header section="Administration" pageTitle="Users" subtitle="Manage platform access and reporting structure" [badgeText]="totalResults + ' total'"
    [actions]="headerActions"></app-page-header>

  <app-page-toolbar searchPlaceholder="Search by name or email..." [filters]="filters"
    [rightText]="userRows.length + ' / ' + totalResults + ' users'" (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)"></app-page-toolbar>

  <app-data-table [columns]="userColumns" [rows]="userRows" [totalResults]="totalResults" [currentPage]="currentPage"
    [itemsPerPage]="itemsPerPage" [showCheckboxes]="true" [showPagination]="true" [resultsLabel]="'users'"
    [serverSidePagination]="true" (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)" [avatarType]="'initials'"
    [actions]="userActions"></app-data-table>

  <!-- Deactivate / Activate confirmation modal -->
  @if (modalData) {
    <app-confirm-action-modal
      [data]="modalData"
      [isOpen]="isModalOpen"
      (actionTriggered)="onModalAction($event)"
      (dismissed)="onModalDismiss()"
    ></app-confirm-action-modal>
  }
</div>